import { fromGearCode } from './DriveCommand';
import { Vehicle } from 'core/models/vehicle';

function parseVehicleStatusLine(s: string) {
    const [
        speed, angle, drivepedal, brakepedal, gear, lamp, light, steeringmode, drivemode
    ] = s.split(',');

    const status = {
        speed: parseFloat(speed),
        steering: parseFloat(angle),
        accel: parseFloat(drivepedal),
        brake: parseFloat(brakepedal),
        gear: fromGearCode(parseInt(gear)),
        blinker: parseInt(lamp),
        light,
        steeringmode,
        mode: parseInt(drivemode),
    };

    return status;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseCurrentPose(_s: string) {
    // console.warn(`receive current_pose message: ${s}`);
    return {};
    /*
    const [
        position_x, position_y, position_z, zone, orientation_x, orientation_y, orientation_z, orientation_w
    ] = s.split(/,/);
    return {
        position_x: parseFloat(position_x),
        position_y: parseFloat(position_y),
        position_z: parseFloat(position_z),
        zone: MAP_INFORMATION.JSG2011.RECTANGULAR_PLANE.WEST_CHUBU,
        orientation_x: parseFloat(orientation_x),
        orientation_y: parseFloat(orientation_y),
        orientation_z: parseFloat(orientation_z),
        orientation_w: parseFloat(orientation_w)
    };
    */
}

export type VehicleStatus = {
    vehicle_id?: string;
    status?: string;
} & Record<string, string>;

export function parseVehicleStatus(vehicleStatusPayload: VehicleStatus) {
    const commonPayload = vehicleStatusPayload;

    const vehicleId = commonPayload.vehicle_id;
    if (!vehicleId) {
        console.log(`invalid vehicle_id: ${JSON.stringify(commonPayload)}`);
        return { statusDelta: {} };
    }

    /*
    const projectId =  this.findProjectId(vehicleId);
    if (!projectId) {
        console.log(`unexpected vehicle_id: ${vehicleId}`);
        return {};
    }
    */

    if (vehicleStatusPayload.status) {
        const status = vehicleStatusPayload.status as string;
        const match = status.match(/^@([_a-zA-Z]+):(.*)/);
        if (match) {
            const topic = match[1];
            const msg = match[2];
            vehicleStatusPayload[topic] = msg;
        } else {
            const columns = status.split(',');
            switch (columns.length) {
                case 9:
                    vehicleStatusPayload['vehicle_status'] = vehicleStatusPayload.status;
                    break;
                case 7:
                    vehicleStatusPayload['current_pose'] = columns.splice(2, 0, '0').join(',');
                    break;
                case 8:
                    vehicleStatusPayload['current_pose'] = vehicleStatusPayload.status;
                    break;
            }
        }
    }

    let newStatus: Partial<Vehicle.Status> = {};

    if (vehicleStatusPayload.vehicle_status) {
        const vehicleStatus = parseVehicleStatusLine(vehicleStatusPayload.vehicle_status);
        newStatus = {
            ...newStatus,
            currentSpeed: vehicleStatus.speed,
            accel: vehicleStatus.accel,
            brake: vehicleStatus.brake,
            steering: vehicleStatus.steering,
            gear: vehicleStatus.gear,
            blinker: vehicleStatus.blinker,
        };
    }

    if (vehicleStatusPayload?.state) {
        const stateMessage = vehicleStatusPayload.state;
        newStatus = {
            ...newStatus,
            stateMessage
        };
    }

    if (vehicleStatusPayload?.current_velocity) {
        const targetSpeed = parseFloat(vehicleStatusPayload.current_velocity);
        newStatus = {
            ...newStatus,
            targetSpeed
        };
    }

    if (vehicleStatusPayload?.current_pose) {
        const currentPose = parseCurrentPose(vehicleStatusPayload.current_pose);
        newStatus = {
            ...newStatus,
            currentPose
        };
    }

    return { vehicleId, statusDelta: newStatus };
}
